import {createApp} from 'vue';
import {connectVue} from '../modules/configureBugsnag';
import trackSocialClicks from '../helpers/trackSocialClicks';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import QuizQuestion from '../components/quiz-question.vue';
import adverts from '../modules/adverts';
import axiosClient from '../modules/axiosClient';
import Newsletter from '../components/newsletter.vue';
import {showImg} from '../helpers/showImg';

const app = createApp({
    components: {
        'quiz-question': QuizQuestion,
        'newsletter': Newsletter,
    },
    props: {
        quiz: Object,
        isLoggedIn: Boolean,
    },
    data() {
        return {
            currentQuestion: null as null|number,
            currentAnswers: [],
            registeringResult: false,
        };
    },
    computed: {
        started(): boolean {
            return this.currentQuestion !== null;
        },
        finished(): boolean {
            return this.currentQuestion > this.quiz.pages.length - 1;
        },
        percentageScore(): number {
            const correctAnswers = this.currentAnswers.filter((answer: any) => answer.correct).length;

            return Math.round(correctAnswers / this.quiz.pages.length * 100);
        },
        loginUrl(): string {
            const currentPageUrl = window.location.pathname;

            return '/login?referring_url=' + btoa(currentPageUrl);
        },
    },
    mounted() {
        this.restoreFromLocalStorage();
    },
    watch: {
        finished(newValue) {
            if (newValue && this.isLoggedIn) {
                this.registerQuizResult();
            }
        },
    },
    methods: {
        showImg(path: string): string {
            return showImg(path, 550);
        },
        startQuiz() {
            this.currentQuestion = 0;
        },
        restartQuiz() {
            window.localStorage.removeItem('quiz-' + this.quiz.id);
            this.currentAnswers = [];
            this.currentQuestion = 0;
        },
        saveToLocalStorage() {
            window.localStorage.setItem('quiz-' + this.quiz.id, JSON.stringify(this.currentAnswers));
        },
        restoreFromLocalStorage() {
            const currentAnswers = window.localStorage.getItem('quiz-' + this.quiz.id);
            if (currentAnswers) {
                this.currentAnswers = JSON.parse(currentAnswers);
            }

            if (this.currentAnswers.length > 0) {
                this.currentQuestion = this.currentAnswers[this.currentAnswers.length - 1].question;
            }
        },
        onAnswered(answerData: any) {
            this.currentAnswers.push(answerData);
            this.saveToLocalStorage();
            this.currentQuestion = this.currentQuestion + 1;
        },
        onRetarget(retargeting: AdTargetingConfig) {
            adverts.retargetAdverts(retargeting);
        },
        socialClick(type: string, url: string) {
            trackSocialClicks(type);
            if (type !== 'whatsapp') {
                window.open(url, 'enquire form', 'width=600, height=400');
            }
        },
        async registerQuizResult() {
            this.registeringResult = true;
            const url = '/api/car-quiz/' + this.quiz.id;
            axiosClient.post(url, {answers: this.currentAnswers}).then((response) => {
                // Spin award handling removed.
            }).finally(() => {
                this.registeringResult = false;
            });
        },
    },
}, window.propsData);

connectVue(app);
configureGlobalComponents(app);
app.mount('#app');
